import React from 'react';
import Login from 'shared/view/login/Login';
import ResetPassword from 'shared/view/login/ResetPassword/ResetPassword';

interface Props {
    location: any;
}

export default function ResetPasswordPage(props: Props) {
    return (
        <ResetPassword {...props}/>
    );
}
